import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";

import { useAuth } from "../contexts/AuthContext";
import { ChalkLogoLockup } from "../components/chalk/Logo";

export default function Join() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { acceptInvite } = useAuth();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) setError("That invite link is missing its token.");
  }, [token]);

  async function onSubmit(e) {
    e.preventDefault();
    if (!password || password.length < 8) {
      setError("At least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      await acceptInvite({ token, password });
      navigate("/app");
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="chalk-min-h-screen" style={{ background: "var(--chalk-bg)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div className="chalk-fadeup" style={{ width: "100%", maxWidth: 400 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
          <ChalkLogoLockup size={28} color="var(--chalk-board)" />
        </div>
        {error && (error.includes("invalid") || error.includes("expired") || error.includes("missing")) ? (
          <div className="chalk-card" data-testid="invite-error">
            <div style={{ fontSize: 16, fontWeight: 500, color: "var(--chalk-board)" }}>This invite isn't usable.</div>
            <div style={{ fontSize: 14, color: "var(--chalk-muted)", marginTop: 6 }}>{error}</div>
            <button onClick={() => navigate("/login")} className="chalk-btn-ghost" style={{ marginTop: 14 }}>
              Back to sign in
            </button>
          </div>
        ) : (
          <>
            <h1 className="font-serif-display" style={{ fontSize: 28, margin: 0, color: "var(--chalk-board)" }}>
              You're on the team.
            </h1>
            <p style={{ fontSize: 14, color: "var(--chalk-muted)", marginTop: 6 }}>
              Set a password to open your Clipboard.
            </p>
            <form onSubmit={onSubmit} style={{ marginTop: 18, display: "grid", gap: 12 }}>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "var(--chalk-muted-2)" }}>
                  <Lock size={16} aria-hidden="true" />
                </span>
                <input
                  type="password"
                  className="chalk-input"
                  placeholder="At least 8 characters"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  data-testid="join-password"
                  aria-label="Password"
                />
              </div>
              {error && <div role="alert" style={{ fontSize: 13, color: "var(--chalk-red)" }}>{error}</div>}
              <button type="submit" className="chalk-btn-primary" disabled={loading} data-testid="join-submit">
                {loading ? "Setting up…" : (<>Open my Clipboard <ArrowRight size={16} aria-hidden="true" /></>)}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
